import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        backgroundColor: '#DE1834',
        color: 'white',
        alignItems: 'center',
        textAlign: 'center',
        height: 40,
        fontSize: 9
    },
    PcsYear: {
        width: '50%',
        textAlign: 'center',
        fontWeight: 'bold'
    },
    EngagedInPracticeOfMedicine: {
        paddingLeft: '2px',
        width: '45%',
        textAlign: 'center',
        fontWeight: 'bold'
    },
    AccreditedCeActivity: {
        paddingLeft: '2px',
        width: '50%',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    PracticeReview: {
        width: '50%',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    ProfessionalDevelopmentPlan: {
        paddingLeft: '2px',
        width: '45%',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    WorkbasedLearning: {
        paddingLeft: '2px',
        width: '45%',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    OnTarget: {
        width: '30%',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    VerificationStatus: {
        width: '40%',
        fontWeight: 'bold',
        textAlign: 'center',
        paddingLeft: '7px'
    }
});

interface Props {
    summaryTitles: string[] | null;
}

const ReceiptTableHeader = ({summaryTitles}: Props) => {
    return (
        <View style={styles.container}>
            <Text style={styles.PcsYear}>{summaryTitles === null ? '' : summaryTitles[0]}</Text>
            <Text style={styles.EngagedInPracticeOfMedicine}>{summaryTitles === null ? '' : summaryTitles[1]}</Text>
            <Text style={styles.AccreditedCeActivity}>{summaryTitles === null ? '' : summaryTitles[3]}</Text>
            <Text style={styles.ProfessionalDevelopmentPlan}>{summaryTitles === null ? '' : summaryTitles[4]}</Text>
            <Text style={styles.PracticeReview}>{summaryTitles === null ? '' : summaryTitles[5]}</Text>
            <Text style={styles.WorkbasedLearning}>{summaryTitles === null ? '' : summaryTitles[6]}</Text>
            <Text style={styles.WorkbasedLearning}>Total</Text>
            <Text style={styles.OnTarget}>{summaryTitles === null ? '' : summaryTitles[7]}</Text>
            <Text style={styles.VerificationStatus}>{summaryTitles === null ? '' : summaryTitles[8]}</Text>
        </View>
    )
};

export default ReceiptTableHeader;
